import type { StateType } from '../../reducers';

export const simProductPriceSelector = (state: StateType): ?number => {
  return state.signUp.simProduct && state.signUp.simProduct.price;
};
